export interface OverviewState {
    allCredentials: Array<Record<string, any>> | null;
    allOAuth: Array<Record<string, any>> | null;
    allFlows: Array<Record<string, any>> | null;
    allUsersInOrganization: Record<string, any> | null;
    statistics: Record<string, any> | null;
    subscription: Record<string, any> | null;
    allEmails: Array<string> | boolean | null;
    allEndpoints: Array<Record<string, any> > | null;
    allManualStartedLogs: Array<Record<string, any> > | null;
    manualStartedLogsThisMonth: Array<Record<string, any> > | null;
    flowsOrder: string[] | null;
    schedulesOrder: string[] | null;
    credentialsOrder: string[] | null;
    workingHours: { startTime: string; endTime: string } | null;
    lastRuns: Array<Record<string, any>> | null;
    runningFlows: Array<Record<string, any>> | null;
    queuedFlows: Array<Record<string, any>> | null;
    futurePlannedDate: { plannedDate: string; plannedDateReadable: string } | null;
    futurePlannedDates: { nextRuns: Array<{ runNumber: number; plannedDate: string; plannedDateReadable: string }> } | null;
}

export const overviewState: OverviewState = {
    allCredentials: null,
    allOAuth: null,
    allFlows: null,
    allUsersInOrganization: null,
    statistics: null,
    subscription: null,
    allEmails: null,
    allEndpoints: null,
    allManualStartedLogs: null,
    manualStartedLogsThisMonth: null,
    flowsOrder: null,
    schedulesOrder: null,
    credentialsOrder: null,
    workingHours: null,
    lastRuns: null,
    runningFlows: null,
    queuedFlows: null,
    futurePlannedDate: null,
    futurePlannedDates: null
}